import React from "react";
import { Layout } from "../Layouts/Layout";
import { useNavigate } from "react-router-dom";
import LottieAnimation from "../Commons/LottieAnimation/LottieAnimation";
import CelebrationAnimation from "../../assets/animations/celebration_animation.json";

const Congratulations = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full h-screen bg-[#000513">
      <div className="flex flex-col h-full justify-center items-center">
        <div className="text-center">
          <div className="flex-1 flex items-center -mx-5 max-h-[230.342px]">
            <LottieAnimation animationData={CelebrationAnimation} />
          </div>
          <div className="flex flex-col gap-1 px-3">
            <span className="text-white text-[36px] font-medium">
              Congratulations
            </span>
            <span className="text-[16px] text-white/70 font-normal">
              You have synced a league from Sleeper
            </span>
          </div>
        </div>
      </div>
      <div
        onClick={() => navigate("/chatbot-ai")}
        className="fixed bottom-0 left-0 right-0 px-6"
        style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 25px)" }}
      >
        <button className="bg-white w-full rounded-[50px] flex items-center justify-center h-[60px]">
          <span className="text-[16px] font-medium text-black">
            Get Started
          </span>
        </button>
      </div>
    </div>
  );
};

export default Congratulations;
